import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { AppBar } from "@mui/material";
import { Tabs, Tab, Box, Typography } from "@mui/material";

import UniCampus from "../../common/uni_campus";
import styles from "./tem_two_campus.module.scss";

// Material ui related
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#fff",
  },
}));

export const TemTwoCampus = ({ uniCampus, universityData }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <section className={styles.tem_two_campus}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2>Campus & Contact</h2>

          <div className="uni_campuses">
            {uniCampus.length > 0 && (
              <div className={classes.root}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    {uniCampus.map((item, i) => (
                      <Tab key={i} label={item?.campusName} {...a11yProps(i)} />
                    ))}
                  </Tabs>
                </AppBar>
                {uniCampus.map((item, i) => (
                  <TabPanel key={i} value={value} index={i}>
                    <UniCampus
                      email={item.email}
                      phone={item.phone}
                      address={`${item.city.name}, ${item.state.name}, ${item.country.name}`}
                      website={item.website}
                      map={item.googleMap}
                    />
                  </TabPanel>
                ))}
              </div>
            )}

            {uniCampus.length == 0 && (
              <UniCampus
                email={universityData.email}
                phone={universityData.phone}
                address={`${universityData.city.name}, ${universityData.state.name}, ${universityData.country.name}`}
                website={universityData.website}
                map={universityData.googleMap}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TemTwoCampus;
